/**
 * @fileoverview GET handler for the "/users/preference_centers" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { usersPreferenceCenters } from "./constants";
import type { UsersPreferenceCentersResult } from "./types";

export const getUsersPreferenceCenters = reactQueryTableFetcherAdapter(
  usersPreferenceCenters,
  async (
    signal: AbortSignal,
    { query, groupby, limit = 20, start = 0, sortby, sortdir }
  ): Promise<UsersPreferenceCentersResult> => {
    return fetch("/users/preference_centers", "GET", { query, groupby, limit, start, sortby, sortdir }, { signal });
  }
);
